'use client'

import type { ReactNode } from 'react'
import React from 'react'

import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons'

import { ddLogger, EmptyState } from '@b-stock/fe-core/bstock-react'

import Footer from '@/components/Footer'
import Header from '@/components/Header'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    ddLogger.error(
      'Error caught by ErrorBoundary in home-portal:',
      { errorInfo },
      error
    )
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Header />
          <EmptyState
            icon={faExclamationTriangle}
            title="500"
            description="Something went wrong. Please try again later."
          />
          <Footer />
        </>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
